export enum Difficults {
    easy = 'easy',
    normal = 'normal',
    hard = 'hard',
    insane = 'insane'
}

export enum Directions {
    up = "up",
    right = "right",
    down = "down",
    left = "left",
}

export enum YesNo {
    yes = 'yes',
    no = 'no'
}